import React from 'react';

import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";

import { ethers } from 'ethers';

const units = {
  wei: {
    nextUnit: 'kwei',
    regexp: /^[0-9]+$/,
    placeholder: '0'
  },
  kwei: {
    nextUnit: 'Mwei',
    regexp: /^[0-9]+(\.[0-9]{1,3})?$/,
    placeholder: '0.000'
  },
  Mwei: {
    nextUnit: 'Gwei',
    regexp: /^[0-9]+(\.[0-9]{1,6})?$/,
    placeholder: '0.000000'
  },
  Gwei: {
    nextUnit: 'szabo',
    regexp: /^[0-9]+(\.[0-9]{1,9})?$/,
    placeholder: '0.000000000'
  },
  szabo: {
    nextUnit: 'finney',
    regexp: /^[0-9]+(\.[0-9]{1,12})?$/,
    placeholder: '0.000000000000'
  },
  finney: {
    nextUnit: 'ether',
    regexp: /^[0-9]+(\.[0-9]{1,15})?$/,
    placeholder: '0.000000000000000'
  },
  ether: {
    nextUnit: 'wei',
    regexp: /^[0-9]+(\.[0-9]{1,18})?$/,
    placeholder: '0.000000000000000000'
  }
};

function EtherValueTextField (props) {
  const {
    value,
    unit = 'ether',
    mandatory = true,
    readOnly = false,
    validator,
    onUnitChange = () => {},
    ...other
  } = props;

  let error = false;
  let helperText = ' ';

  const trimmedValue = value.trim ();
  const lowerCaseValue = trimmedValue.toLowerCase ();

  if (readOnly || (!mandatory && lowerCaseValue === '')) {
    // Do nothing
  } else if (!lowerCaseValue.match (units[unit].regexp)) {
    error = true;
    helperText = lowerCaseValue ? 'Invalid value' : 'Enter valid value, please';
  } else {
    try {
      const bn = ethers.utils.parseUnits (lowerCaseValue, unit);
      if (validator) {
        const validatorMessage = validator (bn);
        if (validatorMessage) {
          error = true;
          helperText = validatorMessage;
        }
      }
    } catch (e) {
      error = true;
      helperText = e.message;
    }
  }

  return (
    <TextField placeholder={readOnly ? undefined : units[unit].placeholder}
               helperText={helperText}
               error={error}
               value={value}
               InputLabelProps={{ shrink: true }}
               InputProps={{
                 readOnly: readOnly,
                 startAdornment: (
                   <InputAdornment position="start">
                     <Button onClick={() => onUnitChange (units[unit].nextUnit)}>
                       {unit}
                     </Button>
                   </InputAdornment>
                 )
               }}
               variant="outlined"
               {...other} />
  );
}

export default EtherValueTextField;
